module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/add-registered-vendor/add-registered-vendor.component.css
// module id = ./src/app/add-registered-vendor/add-registered-vendor.component.css
// module chunks = main